import * as React from 'react';
var FormContext = React.createContext({
  labelAlign: 'right',
  vertical: false
});
export default FormContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_compatible@1.0.2@@ant-design/compatible/es/form/context.js
// module id = 285
// module chunks = 0